$(function(){
  // $('.js-cart-info-popup').hide();
  $('.js-cart-info-popup-close').on('click', function(){
    if ($('.js-cart-info-popup').hasClass('active')) {
      $('.js-cart-info-popup').removeClass('active');
      $('.js-cart-info-popup').fadeOut();
    }
  })
  $('.js-cart-info-popup-open').on('click', function(){
    if (!$('.js-cart-info-popup').hasClass('active')) {
      $('.js-cart-info-popup').fadeIn();
      $('.js-cart-info-popup').addClass('active');
    }
  })
})